/**
 * Global Mock Data Configuration
 * 
 * Toggle this to switch between real API calls and mock data.
 * Set to `true` during Phase 1 frontend development.
 * Set to `false` when connecting to real backend in Phase 4.
 */

// Global toggle - set via environment or manually here
// PHASE 4: All screens wired to real backend
export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK_DATA === 'true';

// Per-feature toggles (override global)
export const MOCK_CONFIG = {
  // Admin Dashboard
  admin: {
    investmentTracker: USE_MOCK_DATA,
    operationsConsole: USE_MOCK_DATA,
    brokersTab: USE_MOCK_DATA,
    investorsTab: USE_MOCK_DATA,
    propertiesTab: USE_MOCK_DATA,
  },
  // Broker Dashboard
  broker: {
    dashboard: USE_MOCK_DATA,
    pipeline: USE_MOCK_DATA,
    investors: USE_MOCK_DATA,
    ledger: USE_MOCK_DATA,
    wallet: USE_MOCK_DATA,
  },
  // Investor Dashboard
  investor: {
    home: USE_MOCK_DATA,
    portfolio: USE_MOCK_DATA,
    properties: USE_MOCK_DATA,
    transactions: USE_MOCK_DATA,
    reports: USE_MOCK_DATA,
  },
  // Public Conversion Flow
  conversion: {
    landing: USE_MOCK_DATA,
    payment: USE_MOCK_DATA,
  },
};

/**
 * Helper to check if mock data should be used for a feature
 * @param {string} dashboard - 'admin' | 'broker' | 'investor' | 'conversion'
 * @param {string} feature - feature name within dashboard
 */
export function useMockData(dashboard, feature) {
  if (MOCK_CONFIG[dashboard] && MOCK_CONFIG[dashboard][feature] !== undefined) {
    return MOCK_CONFIG[dashboard][feature];
  }
  return USE_MOCK_DATA;
}

export default { USE_MOCK_DATA, MOCK_CONFIG, useMockData };
